import React from 'react'
import { Button } from '@chakra-ui/react'

export function SubmitButton({ children, ...props }) {
    return (
        <Button isFullWidth my={2} type="submit" {...props}>
            {children}
        </Button>
    )
}